module.exports = __webpack_public_path__ + "img/logo-lion-parcel.b3d9a060.svg";